module.exports = __webpack_public_path__ + "img/1-sdg-full@2x.ebb072e1.png";